import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { RolesService } from 'src/app/authentification/roles.service';
import { SpinnerService } from 'src/app/core/spinner.service';
import { AlertesService } from 'src/app/shared/alertes.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FormulaireService } from '../../formulaire.service';
import { ModeRenduService } from '../../mode-rendu/mode-rendu.service';
import { SaisieService } from '../../saisie.service';

@Component({
  selector: 'bis-boutons-questionnaire',
  templateUrl: './boutons-questionnaire.component.html',
  styleUrls: ['./boutons-questionnaire.component.css']
})
export class BoutonsQuestionnaireComponent implements OnInit {
  /** permet de n’afficher que le bouton sauvegarder */
  @Input()
  simple = false;
  @Input()
  export = false;
  
  /** permet de prévenir le composant parent de réinitialiser la variable identifiante */
  @Output()
  reinitialisationNoCmpst: EventEmitter<boolean> = new EventEmitter<boolean>();

  /** Liste des alertes pour l'api */
  public listeAlertesForm: Array<string> = new Array<string>();

  constructor(
    private formulaireService: FormulaireService,
    public modeRendu: ModeRenduService,
    public rolesService: RolesService,
    // permet de verrouiller les boutons lorsqu’une requête est en cours
    public spinnerService: SpinnerService,
    private router: Router,
    public alertesService: AlertesService,
    public saisieService: SaisieService
  ) { }

  ngOnInit(): void {
  }

  // Validation gestionnaire
  cliqueEnvoyer() {
    // On lance la synthese au cas où pas fait par l'utilisateur
    this.saisieService.majsSynthese(this.formulaireService.getRootForm().get('syntheseBav'), this.formulaireService.getRootForm().get('bav').get('detailBavs'));

    Swal.fire({
      title: 'Validation',
      text: 'Le questionnaire a bien été validé',
      icon: 'success',
      showCancelButton: false,
      confirmButtonText: 'Fermer'
    }).then((result) => {
      if (result.value) {
            // Envoie des alertes à jour
            this.getListeAlertesFormulaire();

            this.formulaireService.envoyer().subscribe((ok) => {
              if (ok) {
                // Si tout est ok, on réinitialise le questionnaire
                this.reinitialisationNoCmpst.emit(true);
              }
            });
      }
    })
  }

  // Validation enquêté AAV
  cliqueEnvoyerStructure() {
    // On lance la synthese au cas où pas fait par l'utilisateur
    this.saisieService.majsSynthese(this.formulaireService.getRootForm().get('syntheseBav'), this.formulaireService.getRootForm().get('bav').get('detailBavs'));

    Swal.fire({
      title: 'Validation',
      text: 'Votre questionnaire a bien été reçu et validé. Vous pouvez encore le modifier jusqu\'à la date de fin de collecte.',
      icon: 'success',
      showCancelButton: false,
      confirmButtonText: 'Fermer'
    }).then((result) => {
      if (result.value) {
          // Envoie des alertes à jour
          this.getListeAlertesFormulaire();

          this.formulaireService.envoyer().subscribe((ok) => {
            if (ok) {
              // Si tout est ok, on laisse en l'etat le questionnaire affiché
            }
          });
      }
    })
  }

  cliqueEffacer() {
    this.formulaireService.effacerQuestionnaire();
  }

  cliqueSauvegarder() {
    // On lance la synthese au cas où pas fait par l'utilisateur
    this.saisieService.majsSynthese(this.formulaireService.getRootForm().get('syntheseBav'), this.formulaireService.getRootForm().get('bav').get('detailBavs'));

    // Envoie des alertes à jour
    this.getListeAlertesFormulaire();

    // Sauvegarde partielle
    this.formulaireService.sauvegarder().subscribe((ok) => {
      if (ok) {
        // Finalement si tout est ok on laisse le questionnaire chargé en sauvegarde
      }
    });
  }

  cliqueSupprimer() {
    Swal.fire({
      title: 'Attention',
      text: 'Êtes-vous sûr de vouloir supprimer définitivement la saisie en cours ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.value) {
        this.formulaireService.supprimer().subscribe((ok) => {
          if (ok) {
            // Si tout est ok, on réinitialise le questionnaire
            this.reinitialisationNoCmpst.emit(true);
          }
        });
      }
    })
  }

  get formulaire(): UntypedFormGroup {
    return this.formulaireService.getRootForm();
  }

  public getListeAlertesFormulaire(): void {
    // Recuperation des alertes à partir des maps d'alertes de AlertesService
    this.saisieService.getListeAlertesFormulaire(this.formulaire);
  }  
   
}
